export const helpText = `
  <h4>COMMANDS</h4>
  <ul class="asterisk">
    <li><span><strong>GO [place]</strong>: Travel to a nearby place.</span></span></li>
    <li><span><strong>LOOK [thing]</strong>: Look at something, or just look around.</span></li>
    <li><span><strong>TEL [place]</strong>: Teleport to a place.</span></li>
    <li><span><strong>FORGET</strong>: Clear your passport. Cannot be undone.</span></li>
    <li><span><strong>INVENTORY</strong>: Check your inventory.</span></li>
    <li><span><strong>PASSPORT</strong>: Check your passport entries.</span></li>
    <li><span><strong>NOTEBOOK</strong>: Read your notebook.</span></li>
    <li><span><strong>WRITE [text]</strong>: Write a note in your notebook.</span></li>
    <li><span><strong>STATS</strong>: Get some stats about the project.</span></li>
    <li><span><strong>RANDOMWALK [#]</strong>: Walk around the map for # steps.</span></li>
    <li><span><strong>TEXT [small|medium|large|default|#]</strong>: Change the text size.</span></li>
    <li><span><strong>MONITOR [NPC]</strong>: Find out where an NPC is.</span></li>
    <li><span><strong>WIN</strong>: Win the game. This is the best way to cheat.</span></li>
  </ul>
  <p>After typing a command, you can press [TAB] to autocomplete it!</p>
`;
